import { Clock, Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { Crumbs } from "../product/ProductHero";
import { QuoteButton } from "../home/CtaButtons";
import { COMPANY, PHONE_LINK, WHATSAPP_LINK } from "../../lib/constants";
import { trackEvent } from "../../lib/api";

const CHANNELS = [
  { id: "phone", icon: Phone, title: "Bellen", value: COMPANY.phoneDisplay, href: PHONE_LINK, note: "Op werkdagen tijdens openingstijden", track: "click_phone" },
  { id: "whatsapp", icon: MessageCircle, title: "WhatsApp", value: "Stuur een bericht of foto's", href: WHATSAPP_LINK, note: "Handig om direct foto's mee te sturen", track: "click_whatsapp", external: true },
  { id: "email", icon: Mail, title: "E-mail", value: COMPANY.email, href: `mailto:${COMPANY.email}`, note: "Voor uitgebreide vragen of bijlagen", track: "click_email" },
];

export const ContactChannels = () => (
  <ul className="grid gap-3 sm:grid-cols-3" data-testid="contact-channels">
    {CHANNELS.map(({ icon: Icon, ...c }) => (
      <li key={c.id}>
        <a href={c.href} {...(c.external ? { target: "_blank", rel: "noopener noreferrer" } : {})} onClick={() => trackEvent(c.track, { location: "contact_page" })}
          className="card card-hover group flex h-full flex-col p-5" data-testid={`contact-channel-${c.id}`}>
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-maas-soft text-maas transition-colors group-hover:bg-maas group-hover:text-white"><Icon className="h-5 w-5" aria-hidden="true" /></span>
          <span className="mt-4 text-[13px] font-semibold uppercase tracking-[0.12em] text-slate-500">{c.title}</span>
          <span className="mt-1 break-words text-[16px] font-semibold text-ink group-hover:text-maas">{c.value}</span>
          <span className="mt-1 text-[13px] text-slate-500">{c.note}</span>
        </a>
      </li>
    ))}
  </ul>
);

export const ContactHero = ({ crumbs, block }) => (
  <section aria-labelledby="contact-title" className="relative overflow-hidden bg-white" data-testid="contact-hero">
    <div className="hero-grid absolute inset-y-0 right-0 hidden w-[40%] lg:block" aria-hidden="true" />
    <div className="container-tight relative pb-12 pt-6 sm:pt-8 lg:pb-14">
      <Crumbs items={crumbs} />
      <div className="reveal mt-6 max-w-3xl">
        <p className="eyebrow">Contact</p>
        <h1 id="contact-title" className="h1 mt-3 text-balance" data-testid="contact-title">{block.title}</h1>
        <p className="lead mt-4 max-w-2xl" data-testid="contact-lead">{block.body}</p>
        <div className="mt-7"><QuoteButton location="contact-hero" params={{ bron: "contact" }} /></div>
      </div>
      <div className="reveal mt-10 [animation-delay:120ms]"><ContactChannels /></div>
    </div>
  </section>
);

export const ContactAside = () => (
  <aside className="grid content-start gap-4" data-testid="contact-aside">
    <div className="card p-6">
      <h2 className="flex items-center gap-2 text-[17px] font-semibold text-ink"><Clock className="h-4 w-4 text-maas" aria-hidden="true" /> Openingstijden</h2>
      <dl className="mt-3 grid gap-1.5 text-[14.5px]" data-testid="contact-opening-hours">
        {COMPANY.openingHours.map(([d, h]) => <div key={d} className="flex justify-between gap-4"><dt className="text-slate-600">{d}</dt><dd className="font-semibold text-ink">{h}</dd></div>)}
      </dl>
    </div>
    <div className="card p-6">
      <h2 className="flex items-center gap-2 text-[17px] font-semibold text-ink"><MapPin className="h-4 w-4 text-maas" aria-hidden="true" /> Vestiging en werkgebied</h2>
      <p className="mt-3 text-[14.5px] leading-relaxed text-slate-600">Maas Kozijn is gevestigd in {COMPANY.locality}. Wij werken voor particuliere woningeigenaren in heel {COMPANY.region}. Inmeten doen we bij u thuis.</p>
    </div>
    <div className="rounded-2xl bg-ink p-6 text-white">
      <h2 className="text-[17px] font-semibold">Na uw bericht</h2>
      <ol className="mt-3 grid list-decimal gap-2 pl-5 text-[14.5px] text-slate-300">
        <li>U ontvangt een bevestiging per e-mail.</li>
        <li>Wij lezen uw bericht en nemen contact met u op, telefonisch of per e-mail.</li>
        <li>Wilt u verder? Dan plannen we samen een vrijblijvende afspraak.</li>
      </ol>
    </div>
  </aside>
);
